/**
 * HeaderType for dialog component
 */
export enum HeaderType {
  CONFIRM,
  SUCCESS,
  INFO,
  WARNING,
  ERROR
}
